export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        tableAdditionalConfig: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Új beküldő partner',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRow'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }, {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyRow'
            }, {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            }, {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formVisible: false,
            },
            {
                name: "name",
                label: "Név",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: true,
                formType: 'text',
                formSize: 4
            },
            {
                name: "ccCode",
                label: "CC kód",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: true,
                formType: 'ccCode',
                formSize: 4
            },
            {
                name: "useSiteCcCode",
                label: "Ellátóhely CC kód használata",
                filter: {
                    type: "simple",
                },
                visibility: true,
                formVisible: true,
                formSize: 4,
                formType: 'checkbox',
                slot_name: "isSiteCcCodeUsedFormat"
            },
            {
                name: "deleted",
                label: "Törölt",
                filter: {
                    type: "simple",
                },
                visibility: false,
                formVisible: false,
                formType: 'number',
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
